module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }